import React, { ReactNode } from 'react';
import { Checkbox, CheckboxProps } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';

export type InputCheckboxProps = Omit<CheckboxProps, 'aria-label'> & {
	inputId?: string;
	label: string;
	children?: ReactNode;
	labelClassName?: string;
	invalid?: boolean;
	pending?: boolean;
};

export const InputCheckbox = ({
	inputId,
	label,
	children,
	labelClassName,
	invalid = false,
	pending = false,
	id,
	...checkboxProps
}: InputCheckboxProps) => (
	<label
		id={id}
		className={classNames('flex flex-row gap-2 align-items-start', labelClassName)}
		aria-disabled={pending || undefined}
		onClick={(event) => {
			if (pending) {
				event.preventDefault();
			}
		}}
		onKeyDown={(event) => {
			if (pending && (event.key === ' ' || event.key === 'Enter')) {
				event.preventDefault();
			}
		}}
	>
		<Checkbox
			{...checkboxProps}
			id={inputId}
			className={classNames(checkboxProps.className, 'mt-0')}
			aria-label={label}
			onChange={pending ? undefined : checkboxProps.onChange}
		/>
		<span
			style={{ marginTop: 1 }}
			className={classNames({
				'cursor-pointer': !checkboxProps.disabled,
				'text-gray': !invalid && checkboxProps.disabled,
				'text-danger': invalid,
			})}
		>
			{children ?? label}
		</span>
	</label>
);
